class Filter
{
  constructor( options )
  {
    this.filterItem = document.querySelectorAll('.homeFilter__item')
    this.current = "all"
    this.loadMoreButton = document.querySelector('.home__loadButtonContainer')
    this.container1 = document.querySelector('.home__articles--1')
    this.container2 = document.querySelector('.home__articles--2')
    this.mainContainer = document.querySelector('.homeInner')
    this.loadButton = document.querySelector('.home__loadButton')
    this.input = document.querySelector('.homeFilter__searchInput')
    this.dropDown = document.querySelector('.homeFilter__select__dropdown')
    this.buttonDropDown = document.querySelector('.homeFilter__select__title')
    this.offset = 0
    this.search = ""
    this.bindMoreEvent = this.moreEvent.bind(this)
    this.debounceTimer = null
    this.openSelect = false
  }

  removeActive() {
    this.filterItem.forEach(element => {
      element.classList.remove('active')
    });
  }

  moreEvent(e) {
    e.preventDefault()
    this.offset += 1
    this.launchFilter('newGrid')
  }


  launchFilter(type) {
    const that = this
    jQuery.post(
        ajaxurl,
        {
            'action': 'ajax_articles',
            'mainID': this.mainContainer.getAttribute('data-post'),
            'category': this.current === 'all' ? null : this.current,
            'offset': this.offset,
            'search': this.search
        },



        function (response) {
            if(type === 'newGrid') {
                that.mainContainer.innerHTML = response
            }

            setTimeout(() => {
              if(that.loadButton && document.querySelector('.home__loadButton')) {
                that.loadButton.removeEventListener('click', that.bindMoreEvent, true)
                that.loadButton = document.querySelector('.home__loadButton')
                that.loadButton.addEventListener('click', that.bindMoreEvent, true)
              }

            }, 100);
        }
    )
}

  filterNav() {
    this.filterItem.forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        const cat = item.getAttribute('data-slug')
        if(cat) {
          const element = document.querySelector(`.homeFilter__item--${cat}`)
          if(element) {
            this.removeActive()
            element.classList.add('active')
            this.current = cat
            this.offset = 0
            this.closeSelect(element.innerHTML)
          }
        }
        this.launchFilter('newGrid')
        console.log('cat', this.current)
      })
    });
  }
  moreAction() {
    this.loadButton.addEventListener('click', (e) => {
      e.preventDefault()
      this.offset += 1
      this.launchFilter('newGrid')
    })
  }
  debounce(fn, d) {
    let context = this, args = arguments;
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      fn.apply(context, args);
    }, d)
}

  handleSearch(search) {
    this.search = search
    this.launchFilter('newGrid')
  }
  searchEvent() {
    this.input.addEventListener('input', (e) => {
      this.debounce(() => this.handleSearch(e.target.value), 500);
    })
  }

  createSelect() {
    const height = this.dropDown.offsetHeight
    this.dropDown.setAttribute('data-size', height)
    this.dropDown.style.height = 0
    this.dropDown.style.opacity = '1'
    this.dropDown.style.transition = 'all ease 0.5s'
    this.buttonDropDown.addEventListener('click', (e) => {
      e.preventDefault();
      if(!this.openSelect) {
        this.openSelect = true
        this.dropDown.style.height = this.dropDown.getAttribute('data-size') + 'px'
      } else {
        this.openSelect = false
        this.dropDown.style.height =  0
      }
    })
  }

  closeSelect(string) {
    if(this.buttonDropDown && this.dropDown) {
      this.openSelect = false
      this.dropDown.style.height =  0
      this.buttonDropDown.innerHTML = string
    }
  }

  
  init() {
    if(document.querySelector('.homeFilter')) {
      this.createSelect()
      this.filterNav()
      this.searchEvent()
      this.loadButton.addEventListener('click', this.bindMoreEvent, true)
    }
  }
}
export default Filter